<template>
  <div class="position-relative map__height">
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="20"
      :options="mapOptions"
      map-type-id="terrain"
      style="width: 100%; height: 100%;border-radius:10px;"
    >
      <GmapCluster :averageCenter="true" :zoomOnClick="true" :styles="clusterStyles">
        <gmap-custom-marker
          v-for="(m, index) in markers"
          :key="index"
          :marker="m.position"
        >
          <div class="custom__marker__gmap">
            <p class="custom__marker__gmap--text text-truncate">{{ m.name }}</p>

            <!-- <div class="custom__marker__gmap--notification">3</div> -->
            <div class="custom__marker__gmap--downArrow">
              <i class="fas fa-chevron-down"></i>
            </div>

            <!-- On Hover -->
            <div @click.stop="proertyName(m)" class="card gmap__info card-widget widget-user mb-0">
              <div
                class="widget-user-header widget-user-header_spc_lst text-white"
                :style="{backgroundImage: 'url(' + m.img + ')'}"
              >
                <!-- <div class="custom__marker__gmap--notification">3</div> -->

                <div class="gmap__progress">
                  <div style="z-index:10;">
                    <div class="progress-circle__container">
                      <span class="progress-circle__percent">{{ m.occupancy.toFixed(2) }}%</span>

                      <svg
                        class="progress-circle"
                        viewBox="0 0 106 106"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <g
                          id="Page-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g id="ProgressBar" transform="translate(-17.000000, -17.000000)">
                            <circle
                              id="Oval"
                              stroke="#949494"
                              stroke-width="5"
                              fill-rule="nonzero"
                              cx="70"
                              cy="70"
                              r="50"
                            />
                            <path
                              class="progress-circle__path"
                              d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                              id="Oval-Copy"
                              stroke="#f5a623"
                              stroke-width="5"
                              :stroke-dasharray="circle(m.occupancy)"
                              fill-rule="nonzero"
                              transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                            />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <p class="mt-1 txt--xs txt--semi-bold text-white">Occupied</p>
                  </div>
                  <div class="gmap__space">
                    <p class="gmapInfo__space__name txt--ss txt--semi-bold mb-0">{{m.name}}</p>
                  </div>
                </div>
              </div>
              <div class="card-footer p-0 border-0">
                <button type="button" class="info__viewBtn">View Property</button>
                <!-- <button type="button" class="info__viewBtn">View Property</button> -->
              </div>
            </div>
          </div>
        </gmap-custom-marker>
      </GmapCluster>
    </GmapMap>

    <div class="gmap__autoCmplt__wrapper">
      <gmap-autocomplete
        @place_changed="searchPlace"
        @keyup="searchPlace"
        class="gmap__autoCmplt__field"
      ></gmap-autocomplete>
    </div>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
// import { bus } from "../main";
export default {
  name: "Map",
  components: { "gmap-custom-marker": GmapCustomMarker },
  data() {
    return {
      mapOptions: {
        // disableDefaultUI: true,
        clickableIcons: false,
        gestureHandling: "cooperative",
        disableDoubleClickZoom: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        controlSize: 24,
        zoomControlOptions: {
          position: 9,
          style: "google.maps.ZoomControlStyle.SMALL",
        },
        // streetViewControlOptions: {
        //   position: 6
        // },
        // mapTypeControlOptions: {
        //   position: 6
        // },
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d",
              },
            ],
          },
        ],
      },
      clusterStyles: [
        {
          textColor: "white",
          url: require("@/assets/images/m1.png"),
          height: 55,
          width: 56,
          textSize: 12,
          fontFamily: '"Open Sans", sans-serif',
        },
      ],
      center: { lat: 37.7929158, lng: -122.4046905 },
      description: null,
      image: null,
      markers: [],
      places: [],
      search_param: "",
      search_city: "",
    };
  },
  created() {
    this.spaceList(); //get all space list
    // this.autoZoom();
  },
  methods: {
    spaceList() {
      let self_obj = this;
      this.axios
        .post(window.hostname + "api/auth/all-space", {
          limit: 500,
          device_type: 1,
          space_type: 1,
          search_param: this.search_param,
          search_city: this.search_city,
          status: 0,
          page: 1,
          minify: 1,
          minify_2: 0,
          time_zone: this.$moment.tz.guess(new Date()),
        })
        .then((res) => {
          if (res.data.status) {
            let allSpace = res.data.data.all_space;

            // console.log(allSpace);
            if (allSpace.length > 0) {
              self_obj.$emit("search_proprty_list", allSpace);
              this.markers = [];
              for (let i = 0; i < allSpace.length; i++) {
                let name = [];
                name = allSpace[i].property_name!='' ? allSpace[i].property_name : allSpace[i].address.split(",")[0];
                this.markers.push({
                  space_id: allSpace[i].space_id,
                  name: name,
                  description: allSpace[i].address,
                  img: allSpace[i].image,
                  position: {
                    lat: allSpace[i].panorama_latitude ? allSpace[i].panorama_latitude : allSpace[i].latitude,
                    lng: allSpace[i].panorama_longitude ? allSpace[i].panorama_longitude : allSpace[i].longitude,
                  },
                  occupancy: allSpace[i].occupancy_percentage,
                });
              }
              // this.center = {
              //   lat: allSpace[0].panorama_latitude,
              //   lng: allSpace[0].panorama_longitude
              // };
              this.autoZoom(this.markers);
            } else {
              this.markers = [];
              self_obj.$emit("search_proprty_list", []);
            }
          } else {
            this.markers = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    autoZoom(markers) {
      const map = new window.google.maps.LatLngBounds();
      markers.forEach((m) => {
        map.extend(m.position);
      });
      this.$refs.mapRef.fitBounds(map);
      this.$refs.mapRef.panToBounds(map);
    },
    circle(occupancy) {
      return (occupancy / 100) * 100 * Math.PI + ",9999";
    },
    proertyName(space) {
      this.$router.push({ name: "Property", query: { p: space.space_id } });
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    searchPlace(place) {
      // console.log(place);
      if (place.formatted_address) {
        // console.log('here');
        //get city
        this.search_city = "";
        if (place.address_components) {
          // place.address_components.forEach(function (add_component) {
          var i;
          for (i = 0; i < place.address_components.length; i++) {
            if (place.address_components[i].types[0] == "locality") {
              this.search_city = place.address_components[i].long_name;
            }
          }
          // });
        }
        this.search_param = place.formatted_address;
        this.center = {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        };
      } else {
        // console.log('there');
        this.search_param = "";
        this.search_city = "";
        this.center = { lat: null, lng: null };
      }

      this.spaceList();
      // this.$emit("search_city_prop", this.search_city);
    },
  },
};
</script>

<style>
.vue-map-container .vue-map {
  border-radius: 10px;
}
.vue-map-container .vue-map > div {
  background-color: #191919 !important;
}
.vue-map-container .vue-map > div {
  border-radius: 12px;
}
.gm-style .gm-style-iw-t::after {
  background: #f5a623;
  box-shadow: none;
}
.gm-style .gm-style-iw-d {
  overflow: hidden !important;
  padding-right: 18px !important;
  padding-top: 18px !important;
  background-color: transparent !important;
}
.gm-ui-hover-effect {
  display: none !important;
}
.gm-style .gm-style-iw-c {
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  background: transparent !important;
}
.map__height {
  height: 100%;
}
/*======= Map Styling ============*/
.gmnoprint a,
.gmnoprint span,
.gm-style-cc, img[src="https://maps.gstatic.com/mapfiles/api-3/images/google_white5_hdpi.png"]
{
  display: none;
}
#GMapsID div div a div img {
  display: none;
}
.map-control {
  display: none;
}
@media only screen and (max-width: 991px) {
  .map__height {
    height: 500px;
  }
}
</style>